import(/* webpackMode: "eager" */ "/vercel/path0/headapps/irwinmitchell/src/app/error.tsx");
